import { useResetPasswordWithToken } from 'core/Api';
import { useNavigate } from 'react-router-dom';
import { ButtonMantine, PasswordWithStrength, Stack, notifications, validatePassword } from 'ui';
import { useForm } from 'ui/Form';

import { UserResetPasswordWithTokenRequest } from '../../types/user/profile.types';

export const PasswordResetForm = ({
  reset_passwordToken,
}: {
  reset_passwordToken: string | null;
}) => {
  const { mutate: resetPassword } = useResetPasswordWithToken();
  const navigate = useNavigate();
  const form = useForm({
    initialValues: {
      password: '',
      password_confirmation: '',
      current_password: '',
    },
    validate: {
      password: validatePassword,
      password_confirmation: (value, values) =>
        value !== values.password ? 'Passwords must match!' : null,
    },
    validateInputOnBlur: true,
  });

  const handleResetPassword = () => {
    if (!reset_passwordToken) {
      return notifications.show({
        message: 'There was an error resetting your password. Please try again.',
        variant: 'error',
      });
    }
    if (!form.validate().hasErrors) {
      const resetPasswordRequest: UserResetPasswordWithTokenRequest = {
        user: {
          password: form.values.password,
          password_confirmation: form.values.password_confirmation,
          reset_password_token: reset_passwordToken,
        },
      };
      resetPassword(resetPasswordRequest, {
        onSuccess() {
          notifications.show({ message: 'Your password has been reset!', variant: 'success' });
          navigate('/sign-in');
        },
        onError() {
          notifications.show({
            message: 'Please check your password and try again',
            variant: 'error',
          });
        },
      });
    }
  };
  return (
    <Stack>
      <PasswordWithStrength
        placeholder="New password"
        confirmation={true}
        password_confirmation_props={form.getInputProps('password_confirmation')}
        {...form.getInputProps('password')}
      />
      <ButtonMantine variant="gradient" onClick={handleResetPassword}>
        Reset Password
      </ButtonMantine>
    </Stack>
  );
};
